import { Modal, Button, Form } from "react-bootstrap";
import { useState } from "react";
import { createItems } from "../../api/api";

const CreateItem = ({ show, onHide, onCreated }) => {
    const [name, setName] = useState("");
    const [loading, setLoading] = useState(false);

    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);
        try {
            await createItems([{ name }]);
            setName("");
            onCreated && onCreated();
        } catch (err) {
            alert("Error creating item");
        } finally {
            setLoading(false);
        }
    };

    return (
        <Modal show={show} onHide={onHide} centered>
            <Form onSubmit={handleSubmit}>
                <Modal.Header closeButton>
                    <Modal.Title>Create New Item</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Form.Group className="mb-3">
                        <Form.Label>Name</Form.Label>
                        <Form.Control
                            type="text"
                            value={name}
                            onChange={e => setName(e.target.value)}
                            required
                        />
                    </Form.Group>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={onHide} disabled={loading}>
                        Cancel
                    </Button>
                    <Button variant="primary" type="submit" disabled={loading}>
                        {loading ? "Creating..." : "Create"}
                    </Button>
                </Modal.Footer>
            </Form>
        </Modal>
    );
};

export default CreateItem;
